import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// @ts-ignore
import MouseHandler from "./mouse_handler";
import { LEFT_BUTTON, RIGHT_BUTTON } from "./util";

var MouseRotateHandler = /*#__PURE__*/function (_MouseHandler) {
  _inherits(MouseRotateHandler, _MouseHandler);

  var _super = _createSuper(MouseRotateHandler);

  function MouseRotateHandler() {
    _classCallCheck(this, MouseRotateHandler);

    return _super.apply(this, arguments);
  }

  _createClass(MouseRotateHandler, [{
    key: "contextmenu",
    value: function contextmenu(e) {
      // prevent browser context menu when necessary; we don't allow it with rotation
      // because we can't discern rotation gesture start from contextmenu on Mac
      e.preventDefault();
    }
  }, {
    key: "correctButton",
    value: function correctButton(e, button) {
      return button === LEFT_BUTTON && e.ctrlKey || button === RIGHT_BUTTON;
    }
  }, {
    key: "move",
    value: function move(lastPoint, point) {
      var degreesPerPixelMoved = 0.8;
      var bearingDelta = (point.x - lastPoint.x) * degreesPerPixelMoved;

      if (bearingDelta) {
        this.active = true;
        return {
          bearingDelta: bearingDelta
        };
      }
    }
  }]);

  return MouseRotateHandler;
}(MouseHandler);

export { MouseRotateHandler as default };